import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { landingPageMetaProps, dummyListingObject } from '../../util/misc';
import { LayoutComposer, NamedLink, ListingCard, LandingPagesSubFooter, IconSpinner } from '../../components';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getListingsById } from '../../ducks/marketplaceData.duck';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import StaticPage from '../PageBuilder/StaticPage';

import { ReactComponent as RightArrowIcon } from '../../assets/landingAssets/rightArrow.svg';
import { ReactComponent as GemIcon } from '../../assets/landingAssets/gem.svg';
import { ReactComponent as BagIcon } from '../../assets/landingAssets/bag.svg';
import { ReactComponent as ShipIcon } from '../../assets/landingAssets/ship.svg';
import { ReactComponent as LockIcon } from '../../assets/landingAssets/lock.svg';
import { ReactComponent as ArrowRightIcon } from '../../assets/landingAssets/arrowRight.svg';

// import jewelerPageWhyImage from '../../assets/landingAssets/modelWearingGem.png';
import jewelerPageWhyImage from '../../assets/landingAssets/jeweler_woman.png';
import listingCardHeader from '../../assets/landingAssets/listingCardHeader.png';
import mainLogoGreen from '../../assets/landingAssets/mainLogoGreen.png';
import xLogo from '../../assets/landingAssets/logoX.png';
import css from './JewelerLandingPage.module.css';


const JewelerLandingPageComponent = props => {
    const { listings, searchInProgress, searchListingsError, location, currentUser } = props;

    const listingsRef = useRef(null);
    const isFirstRender = useRef(true);


    useEffect(() => {
        if (!isFirstRender.current) {
            setTimeout(() => {
                listingsRef.current?.scrollIntoView({ behavior: 'auto' });
            }, 0);
        } else {
            isFirstRender.current = false;
        }
    }, [location.key]);

    const layoutAreas = `
    topbar
    main
    footer
  `;

    const pageMetaProps = landingPageMetaProps;
    const dummyListing = {
        ...dummyListingObject,
        image: listingCardHeader,
    };

    // const percentageText = <span className={css.percentageText}>
    //     <FormattedMessage id="JewelerLandingPage.percentageText" />
    // </span>

    return <StaticPage {...pageMetaProps}>
        <LayoutComposer areas={layoutAreas} className={css.layout}>
            {props => {
                const { Topbar, Main, Footer } = props;
                return <>
                    <Topbar as="header" className={css.topbar}>
                        <TopbarContainer currentPage="LandingPage" />
                    </Topbar>
                    <Main as="main" className={css.main}>
                        <div className={css.hero}>
                            <div className={css.heroLeft}>
                                <div className={css.smallTitle}>
                                    <FormattedMessage id="JewelerLandingPage.smallTitle" />
                                </div>
                                <h1 className={css.title}>
                                    <FormattedMessage id="JewelerLandingPage.title" />
                                </h1>
                                <div className={css.subTitle}>
                                    <FormattedMessage id="JewelerLandingPage.subTitle" />
                                </div>
                                <div className={css.cta}>
                                    <NamedLink name="SignupPage" className={css.signupCta}>
                                        <FormattedMessage id="JewelerLandingPage.signupCta" />
                                        <RightArrowIcon />
                                    </NamedLink>
                                    {/* <NamedLink name="SearchPage" className={css.searchCta}>
                                        <FormattedMessage id="JewelerLandingPage.searchCta" />
                                    </NamedLink> */}
                                </div>
                                <div className={css.stats}>
                                    <div className={css.stat}>
                                        <div className={css.figure}>
                                            <FormattedMessage id="JewelerLandingPage.stats.figure1" />
                                        </div>
                                        <div className={css.figureLabel}>
                                            <FormattedMessage id="JewelerLandingPage.stats.figure1Label" />
                                        </div>
                                    </div>
                                    <div className={css.stat}>
                                        <div className={css.figure}>
                                            <FormattedMessage id="JewelerLandingPage.stats.figure2" />
                                        </div>
                                        <div className={css.figureLabel}>
                                            <FormattedMessage id="JewelerLandingPage.stats.figure2Label" />
                                        </div>
                                    </div>
                                    <div className={css.stat}>
                                        <div className={css.figure}>
                                            <FormattedMessage id="JewelerLandingPage.stats.figure3" />
                                        </div>
                                        <div className={css.figureLabel}>
                                            <FormattedMessage id="JewelerLandingPage.stats.figure3Label" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={css.heroRight}>
                                <ListingCard
                                    className={css.listingCard}
                                    listing={dummyListing}
                                    showAuthorInfo={false}
                                    noLink={true}
                                    noPrice={true}
                                />
                            </div>
                        </div>

                        <div className={css.section}>
                            {/* <div className={css.gemXLogo}>
                                <img src={mainLogoGreen} />
                            </div> */}
                            <h3 className={css.gemExpTitle}>
                                <img src={xLogo} className={css.xLogo} /> <FormattedMessage id="JewelerLandingPage.gemExpTitle" />
                            </h3>
                            <div className={css.gemExps}>
                                <div className={css.gemExp}>
                                    <GemIcon />
                                    <div className={css.gemExpLabel}>
                                        <FormattedMessage id="JewelerLandingPage.gemExpLabel1" />
                                    </div>
                                    <div className={css.gemExpText}>
                                        <FormattedMessage id="JewelerLandingPage.gemExpText1" />
                                    </div>
                                </div>
                                <div className={css.gemExp}>
                                    <BagIcon />
                                    <div className={css.gemExpLabel}>
                                        <FormattedMessage id="JewelerLandingPage.gemExpLabel2" />
                                    </div>
                                    <div className={css.gemExpText}>
                                        <FormattedMessage id="JewelerLandingPage.gemExpText2" />
                                    </div>
                                </div>
                                <div className={css.gemExp}>
                                    <ShipIcon />
                                    <div className={css.gemExpLabel}>
                                        <FormattedMessage id="JewelerLandingPage.gemExpLabel3" />
                                    </div>
                                    <div className={css.gemExpText}>
                                        <FormattedMessage id="JewelerLandingPage.gemExpText3" />
                                    </div>
                                </div>
                                <div className={css.gemExp}>
                                    <LockIcon />
                                    <div className={css.gemExpLabel}>
                                        <FormattedMessage id="JewelerLandingPage.gemExpLabel4" />
                                    </div>
                                    <div className={css.gemExpText}>
                                        <FormattedMessage id="JewelerLandingPage.gemExpText4" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={css.whyColombian}>
                            <div className={css.whyColombianImg}>
                                <img src={jewelerPageWhyImage} />
                            </div>
                            <div className={css.whyColombianContent}>
                                <div className={css.whyColombianTitle}>
                                    <FormattedMessage id="JewelerLandingPage.whyColombianTitle" />
                                </div>
                                <div className={css.whyColombianText}>
                                    <FormattedMessage
                                        id="JewelerLandingPage.whyColombianText"
                                    // values={{ percentageText }}
                                    />
                                </div>
                                <div className={css.whyColombianPoints}>
                                    {Array(4).fill("").map((_, i) => {
                                        return <div key={i} className={css.whyColombianPoint}>
                                            <div className={css.whyColombianPointL}>
                                                <div className={css.whyColombianPointLabel}>
                                                    <FormattedMessage id={`JewelerLandingPage.whyColombianPoint${i + 1}Label`} />
                                                </div>
                                                <div className={css.whyColombianPointText}>
                                                    <FormattedMessage id={`JewelerLandingPage.whyColombianPoint${i + 1}Text`} />
                                                </div>
                                                <div className={css.whyColombianDivider} />
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>
                        </div>

                        {/* <div className={css.collectionsSection} ref={listingsRef}>
                            <div className={css.collectionsSectionTitle}>
                                <FormattedMessage id="CustomerLandingPage.collectionsSectionTitle" />
                            </div>
                            <div className={css.listingsSection}>
                                <div className={css.filters}>
                                    {[
                                        { id: 'muzo', label: 'Muzo', search: '?pub_originRegion=muzo' },
                                        { id: 'high-clarity', label: 'High Clarity', search: '?pub_clarityGrade=eyeClean' },
                                        { id: 'no-oil', label: 'No Oil', search: '?pub_treatmentLevel=noOil' },
                                        { id: 'investment', label: 'Investment', search: '?price=10000,50000&pub_caratWeight=2,10' },
                                        { id: 'affordable', label: 'Affordable', search: '?price=1,2000' },
                                    ].map(filter => (
                                        <NamedLink
                                            key={filter.id}
                                            name="JewelerLandingPage"
                                            to={{ search: filter.search }}
                                            className={classNames(css.filterButton, { [css.filterActive]: location.search === filter.search })}
                                        >
                                            {filter.label}
                                        </NamedLink>
                                    ))}
                                </div>
                                <div className={css.listings}>
                                    {searchInProgress ? (
                                        <div className={css.spinnerWrapper}>
                                            <IconSpinner className={css.spinner} />
                                        </div>
                                    ) : listings.length === 0 ? (
                                        <div className={css.noListings}>
                                            <FormattedMessage id="JewelerLandingPage.noListings" />
                                        </div>
                                    ) : (
                                        <div className={css.listingCardContainer}>
                                            {listings.map(l => (
                                                <div key={l.id.uuid} className={css.listingCardWrapper}>
                                                    <ListingCard listing={l} showAuthorInfo={false} />
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    {searchListingsError && (
                                        <p className={css.error}>
                                            {typeof searchListingsError === 'string'
                                                ? searchListingsError
                                                : searchListingsError.message || 'An error occurred'}
                                        </p>
                                    )}
                                </div>
                                <div className={css.viewFullCatalogueWrapper}>
                                    <NamedLink name="SearchPage" to={{ search: location.search }} className={css.viewFullCatalogue}>
                                        <FormattedMessage id="JewelerLandingPage.viewFullCatalogue" />
                                        <ArrowRightIcon />
                                    </NamedLink>
                                </div>
                            </div>
                        </div> */}
                        <div className={css.readyToExploreSection}>
                            <div className={css.readyToExploreContent}>
                                <div className={css.readyToExploreTextWrapper}>
                                    <div className={css.readyToExploreTitle}>
                                        <FormattedMessage id="JewelerLandingPage.readyToExploreTitle" />
                                    </div>
                                    <div className={css.divider}></div>
                                    <div className={css.readyToExploreText}>
                                        <FormattedMessage id="JewelerLandingPage.readyToExploreText" />
                                    </div>
                                </div>
                                <div className={css.ctaWrapper}>
                                    <NamedLink
                                        name={currentUser ? 'ProfileSettingsPage' : 'SignupPage'}
                                        className={css.dealerPortalCta}
                                    >
                                        <FormattedMessage id="JewelerLandingPage.dealerPortalCta" />
                                    </NamedLink>
                                    <NamedLink name="SearchPage" className={css.shopJewelryCta}>
                                        <FormattedMessage id="JewelerLandingPage.shopJewelryCta" />
                                    </NamedLink>
                                </div>
                            </div>
                        </div>
                    </Main>
                    <Footer>
                        <div className={css.subFooterWrapper}>
                            <LandingPagesSubFooter mode="light" />
                        </div>
                        <FooterContainer />
                    </Footer>
                </>
            }}
        </LayoutComposer>
    </StaticPage >
};

const mapStateToProps = state => {
    const { currentUser } = state.user;
    const {
        currentPageResultIds,
        pagination,
        searchInProgress,
        searchListingsError,
    } = state.JewelerLandingPage;
    const listings = getListingsById(state, currentPageResultIds);

    return {
        currentUser,
        listings,
        pagination,
        searchInProgress,
        searchListingsError,
    };
};

const JewelerLandingPage = compose(
    connect(
        mapStateToProps,
    )
)(JewelerLandingPageComponent);

export default JewelerLandingPage;
